
































































































































































































import { Utils } from '@/helper/utils';
import { Component } from 'vue-property-decorator';
import { Base } from './base';

@Component({
  props: [
    'url',
    'customerKey',
    'vin',
    'amount',
    'totalAmount',
    'invoiceNumber',
    'tenantId',
    'enterpriseId',
    'storeId',
    'dealId',
    'storeName',
    'address',
    'zipcode',
    'city',
    'state',
    'phoneNumber',
    'firstName',
    'lastName',
    'comments',
    'transactionHeaderId',
    'lastPaymentDetailId',
    'loggedInUserId',
    'loggedInUserEmail',
    'customerEmail',
    'merchantEmail',
    'recordKey',
    'recordIdentifier',
    'type',
    'cloverDialog',
    'showTextField',
    'other',
    'selectedCharges',
    'name',
    'account',
    'control',
    'reference',
    'description',
    'lineItems',
    'isAmountOverride',
    'isDeductiblePayment',
    'isSendPaymentReceipt'
  ],
})
export default class CloverPayment extends Base {
  public cloverUrl: string = Utils.WEB_BASE_URL + '/serverpay/clover';

  public close() {
    this.$emit('cloverDialog', false);
  }
}
